var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTheHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.5 155.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#9fb9d3}.cls-3{fill:#cedbe8}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.71 318.25v21.5L254 388.42l8.67 3.83 22.5-19.17 5.33 2.67-1 62.17h6.5l6-40h2.67l4 43.33h7.67l.83-42.5H320l6.5 38.5h6.33s-4-42.75-3.83-44.33 2.92-2.75 5-.67 18.5 28.83 18.5 28.83l3.92-3.92-19.58-43.75s-4.46-22.58-6.5-29.33-1-25.83-1-25.83z",
    transform: "translate(-235.25 -318.25)",
    fill: "#7ba7d2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.5,
    cy: 80.5,
    r: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 55.5,
    cy: 129.5,
    r: 4.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 79,
    cy: 134,
    r: 4.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 79,
    cy: 151,
    r: 4.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 52,
    cy: 146,
    r: 4.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100.75,
    cy: 131,
    r: 4.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 127,
    cy: 111,
    r: 4.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 105.25,
    cy: 147,
    r: 4.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 137,
    cy: 125,
    r: 4.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 4.5,
    cy: 93.5,
    r: 4.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheHand);
export default __webpack_public_path__ + "static/media/the-hand.5f59a6a24a63e18e4243d6aca285bda2.svg";
export { ForwardRef as ReactComponent };